<style lang="scss" scoped>
	@import "./trpllore.css";
</style>
<template>
	<div id="trpllore">
		<div class="topHeader">
			<a-form-model :model="params" style="width:100%;" labelAlign="right" layout="inline">
						<a-row type='flex' justify='space-between'>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="證券帳號" class="formItem">
									<!-- <Situationall v-model="params.area" :url='$api.getParamList' ref='seachope'
										:params='{"type":"kharea"}' :style='"width:100%"' :placeholder="'請選擇證券帳號'">
									</Situationall> -->
									<a-input v-model="params.username" placeholder="請輸入證券帳號" :allowClear="true" @change="handleClear()"/>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="登錄方式" class="formItem">
									<a-select v-model="params.logintype" placeholder="請選擇登錄方式" @change='searchEvent'>
										<a-select-option v-for="(item) in admintypeArr" :key="item.key"
											:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="登錄狀態" class="formItem">
									<a-select v-model="params.loginstatus" placeholder="請選擇查詢信息" @change='searchEvent'>
										<a-select-option v-for="(item) in ontypearr" :key="item.key"
											:value="item.value" style='width:100%'>{{item.text}}</a-select-option>
									</a-select>
								</a-form-model-item>
							</a-col>
							<a-col :xl="{ span: 5 }">
								<a-form-model-item label="登錄時間" class="formItem">
									<a-range-picker :placeholder="['開始時間','結束時間']" format="YYYY/MM/DD"
										v-model="params.timeDate" @change='fanhand'>
									</a-range-picker>
								</a-form-model-item>
							</a-col>
							<a-col style="display: inline-flex;align-items: center;">
								<div class="btn_cla" style="background-color:#3bc7a1;margin-right: 1rem;" 
								@click="searchEvent">
									<img src="../../image/icon_sousuo.png" class="btnIcon" />
									<span>搜索</span>
								</div>
								<div class="btn_cla" style="background-color:#ffa647;"
									@click="clearEvent">
									<img src="../../image/icon_chongzhi.png" class="btnIcon" />
									<span>重置</span>
								</div>
							</a-col>
						</a-row>
			
			</a-form-model>
		</div>
		<div class="bottomMain">
			<div class="tableBtnView">
				<div @click='upClick()' style="cursor: pointer;">
					<!-- handopen pdfEvent-->
					<!-- <img :src="require('../../image/pdf.png')" class="btnIcon" style='width: .9rem'/> -->
					<a-icon type="file-pdf" style='width: .9rem;color: #3bc7a1;marginRight:.3rem;fontSize:.8rem' />
					<span style="color:#3bc7a1;">導出</span>
				</div>
			</div>
			<a-table style="width:100%;" :columns="columns" :data-source="columnsData" id='fromtable'
				:rowKey='(record, index) => index'
				:row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }" :pagination="false"
				:bordered="true">
				<div slot='loginstatus' slot-scope="record" style="white-space: nowrap;">
					<div v-if='record.loginstatus == "1"' >
							<span style="font-size: 0.85rem !important;color: rgb(59, 199, 161);">已登錄</span>
					</div>
					<div v-if='record.loginstatus == "2"'>
						<span style="font-size: 0.85rem !important;color: #ee5253;">未登錄</span>
						</div>
				</div>
				
				<div  slot='area' slot-scope="record">
					<span v-if="record == '加拿大魁北克魁北克'">加拿大魁北克</span>
					<span v-else>{{record}}</span>
					
				</div>
				<!-- 控制按鈕 -->
				<!-- <div slot="toolArr" slot-scope="record">
					<div class="tableRowView2">
						<div>
							<img :src="require('@/image/icon_xiangqing.png')" :style="{opacity:record.loginstatus == '已提交'||record.cancelflag==1?'.5':'1'}" class="imageC"
								@click='visible_bold = true;itemobj=record'>
						</div>
					</div>
				</div> -->
			</a-table>
			<div class="paginationView">
				<div>第{{firstPage}}到{{secPage}}條，共{{params.total}}條記錄</div>
				<div style="margin-left:auto;">
					<a-pagination v-model="params.pageNum" @change="pageChange" :total="params.total"
						:pageSize="params.perPage" />
				</div>
				<div class="pageTzView">
					<input type="text" v-model="tzPageNum" @onkeyup="valueFn" @onafterpaste="valueFn">
					<span @click="tzEvent">跳轉</span>
				</div>
			</div>
		</div>
		<div :class="['pdfview',pdfShow ? 'pdfShow' : '']" @click="pdfShowUNEvent()">
			<div class="pdfviewIn">
				<div class="pdfTitle">
					<img @click.stop="printEvent()" src="../../image/icon_dayin.png">
				</div>
				<iframe id="iframePdf1" :src="allurl" style="width: 100%; height: 100%" frameborder="0"></iframe>
				<iframe id="toPrintIframe" style="display:none;" :src="pdfBolUrl" frameborder="0"></iframe>
			</div>
		</div>
		<!-- 搜索无结果弹窗 -->
		<div>
            <a-modal  id='handout' width='25rem' v-model="ishandout" on-ok="handleOk1" v-dragModal :dialog-style='{top:"30vh"}'  @cancel="handleCancel(0)" :footer="null" :keyboard='false' :maskClosable='false'>
                <div class='mark-file' style="overflow: hidden;width: 100%;borderBottom: 1px solid #f1f1f1;">
                    <div style="border-radius:0;width: 23rem;float: right;background-color: #fff;color:#000;text-align: left;padding-bottom: .5rem 0;position: relative;top: -.5rem;left: -0.5rem;">
                        提 示
                    </div>
                </div>
                <div solt='title' style="position: relative;"></div>
                <div style='margin-top: 3rem;height: 3rem;font-size:.8rem;line-height:3rem;display: flex;align-items: center;'>
                    <a-icon type="exclamation-circle" style='font-size: 1.2rem;color: orange;margin-right:.5rem;'/>	搜索內容不存在
                </div>
                <div style="text-align: right">
                    <button class='btn-main btn-main1' @click='ishandout = false'>取 消</button>
                    <button class='btn-main' @click='ishandout = false'>確 認</button>
                </div>
            </a-modal>
        </div>
		<exportData  v-if="upFlag" @child="upclose" ></exportData>
		<!-- <handItem v-if='visible_bold' @child='handclose' :itemobj='itemobj'></handItem> -->
	</div>
</template>
<script>
	import exportData from "./exportData.vue";
	import https from '@/plugins/http.js';
	import App from '@/assets/app.js';
	// import handItem from './components/handItem'

	export default {
		components: {
			exportData
			// handItem
		},
		data() {
			return {
				upFlag:false,
				allurl: '',
				ishandout: false,
				pdfShow: false,
				pdfBolUrl: '',
				itemobj: {},
				visible_bold: false,
				//: "編輯管理員": "ipoAdmin"有新增 编辑权限    
				ipoAdmin: this.$store.state.rolesdata.indexOf('ipoAdmin') >= 0,
				admintypeArr: [ {
						text: '全部',
						value: ''
					},{
						text: 'Password',
						value: '1'
					},{
						text: 'Touch ID',
						value: '2'
					},{
						text: 'Face ID',
						value: '3'
					},
				],
				ontypearr: [ {
						text: '全部',
						value: ''
					},{
						text: '已登錄',
						value: '1'
					},{
						text: '未登錄',
						value: '2'
					},
				],
				tzPageNum: '',
				columns: [
					{
						title: '證券帳號',
						dataIndex: 'username',
						align: 'center',
						width: '12%',
					},
					{
						title: '登錄平台',
						dataIndex: 'loginarea',
						align: 'center',
						width: '10%',
					},
					{
						title: '登錄語言',
						dataIndex: 'lang',
						align: 'center',
						width: '8%',
					},
					{
						title: '登錄方式',
						dataIndex: 'logintype',
						align: 'center',
						width: '11%',
					},
					{
						title: 'IP地址',
						dataIndex: 'ip',
						align: 'center',
						width: '12%',
					},
					{
						title: '國家/地區',
						dataIndex: 'area',
						align: 'center',
						width: '12%',
						scopedSlots: {
							customRender: 'area'
						}
					},
					{
						title: '登錄時間',
						dataIndex: 'logintime',
						align: 'center',
						width: '12%',
					},
					{
						title: '登錄狀態',
						dataIndex: '',
						align: 'center',
						width: '10%',
							scopedSlots: {
								customRender: 'loginstatus'
							}
					},
					{
						title: '備註',
						dataIndex: 'remark',
						align: 'center',
						width: 'auto',
					},
				],
				columnsData: [],
				selectedRows: [], //checkbox
				params: { // 任務數
					missionnum: 0,
					pageNum: 1, //當前頁數
					total: 1,
					loginstatus: '',
					perPage: 10, //每頁條目數
					username: '',
					logintype: '',
					logintime_begin: '', //認購起始日期
					logintime_end: '', //認購截止日期
					timeDate: [],
				}
			}
		},
		created() {},
		computed: {
			firstPage: function() {
				let _this = this;
				let a = (_this.params.pageNum - 1) * 10;
				let b = 1;
				return _this.params.total > 0 ? Number(a) + Number(b) : 0
			},
			secPage: function() {
				let _this = this;
				let a = _this.params.pageNum * 10;
				let b = a > _this.params.total ? _this.params.total : a;
				return b
			},
		},
		mounted() {
			this.messLoad();
		},
		methods: {
			handleCancel(ev){
                this.ishandout = false
			},
			handleClear(val){
                if (!this.params.username) {
                    this.messLoad()
                }
            },
			upClick(){
				this.upFlag = true
			},
			upclose(val){
				this.upFlag = false;
				if (val.xzgs == 'PDF') {
					this.pdfEvent(val.pxfs)
				}
				if (val.xzgs == 'Excel') {
					this.queryData(val.pxfs)
				}
			},
			queryData(val){
				let brr =[];
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['id']){
						brr.push(this.columnsData[ev]['id'])
					}
				})
				let url = ''
				let _this = this;
				let sort =  val == undefined ? "" : val
				url = _this.$api.exportTradingPlatformExcel;
				url += '?token=' + _this.$store.state.token
				url += '&m=' + Date.parse(new Date())
				url += '&logintime_begin=' + this.params.logintime_begin
				url += '&logintime_end=' + this.params.logintime_end
				url += '&loginstatus=' + this.params.loginstatus
				url += '&logintype=' + this.params.logintype
				url += '&username=' + this.params.username
				url += '&sort=' + sort
				url += '&loginidList=' + brr.join(',')
				console.log(url);
				window.location.href = url;
			},
			pdfEvent(pxfs) {
				let brr =[];
				this.selectedRows.map(ev=>{
					if(this.columnsData[ev]['id']){
						brr.push(this.columnsData[ev]['id'])
					}
				})
				let str = this.$api.pdfs; //getUnsk
				// let url = this.$api.getUnsk;
				let url = this.$api.getQmisUserLoginLogsPdf;
				let sort =  pxfs == undefined ? '' : pxfs
					// url += '?m=' + Date.parse(new Date())
				url += '?logintime_begin=' + this.params.logintime_begin + '&logintime_end=' + this.params.logintime_end + '&token=' + this.$store
						.state.token + '&m=' + Date.parse(new Date())
						+'&loginstatus=' + this.params.loginstatus
						+'&logintype=' + this.params.logintype
						+'&username=' + this.params.username
						+ '&sort=' + sort
						+'&loginidList=' + brr.join(',')
						
				this.allurl = str + url
				let _this = this;
				_this.pdfUrl = url
				https.fetchGetPdf(_this.pdfUrl).then((data) => {
					let blob = new Blob([data], {
						type: 'application/pdf'
					});
					_this.blob = blob;
					let b = window.URL.createObjectURL(blob);
					_this.pdfBolUrl = b;
				}).catch(err => {
					console.log(err);
				});

				setTimeout(() => {
					this.pdfShow = true;
				}, 500);
				// window.open(this.$api.openurls+ "/dalinji")
			},
			printEvent() {
				let _this = this; //toPrintIframe
				const printIframe = document.getElementById("toPrintIframe");
				let frameWindow = printIframe.contentWindow;
				console.log(frameWindow)
				frameWindow.print();
				setTimeout(() => {
					window.URL.revokeObjectURL(_this.blob);
				}, 500)
			},
			pdfShowUNEvent() {
				this.pdfShow = false;
				// this.messLoad();
			},
			handopen() {
				this.$ajax({
					url: this.$api.getpdfable,
					method: 'post',
				}).then(res => {
					if (res.data.qmiscode == 1000) {
						window.location.href = this.$api.getUn + '?token=' + this.$store.state.token + '&m=' + Date
							.parse(new Date()) +
							'&logintime_begin=' + this.params.logintime_begin + '&logintime_end=' + this.params.logintime_end
						// window.location.href = this.$api.getExcel+'?token=' + this.$store.state.token + '&m=' + Date.parse(new Date())
					}
				})
			},
			onSelectChange(selectedRowKeys) {
				this.selectedRows = selectedRowKeys;
			},
			valueFn() {
				this.tzPageNum = this.tzPageNum.replace(/\D/g, '')
			},
			fanhand(val) {
				this.params.logintime_begin = this.params.timeDate[0] ? App.oDate.secsTime3(this.params.timeDate[0]
						._d) : '',
					//認購截止日期
				this.params.logintime_end = this.params.timeDate[1] ? App.oDate.secsTime3(this.params.timeDate[1]
						._d) : ''
			},
			handclose(val) {
				this.itemobj = {}
				this.visible_bold = false;
				if (val) {
					this.messLoad();
				}
			},
			messLoad() {
				this.selectedRows = []
				this.$ajax({
					method: 'post',
					url: this.$api.getQmisUserLoginLogs,
					headers: {
						token: this.$store.state.token
					},
					data: this.params
				}).then(res => {
					if (res.data.qmiscode === 1000) {
						this.columnsData = res.data.qmisUserLoginLogList
						this.columnsData.map(ev => {
							for (let key in ev) {
								ev['visible_bold'] = false
							}
						})

						this.params.pageNum = res.data.pageNum
						this.params.perPage = res.data.perPage
						this.params.pages = res.data.pages
						this.params.total = res.data.total
						this.params.missionnum = res.data.missionnum
						if (this.params.username || this.params.logintype || this.params.loginstatus || this.params.logintime_begin) {
							if (this.columnsData.length<=0) {
								this.ishandout = true
							}
						}
					} else {
						App.oTool.warningT(res.data.qmismsg);
					}
				}).catch(err => {
					console.log(err);
				});
			},
			searchEvent() {
				this.params.pageNum = 1;
				this.messLoad();
			},

			clearEvent() {
				this.params = {}
				this.params = {
					pageNum: 1, //當前頁數
					total: 1,
					perPage: 10, //每頁條目數
					username: '', 
					loginstatus:'',
					logintime_begin: '', //認購起始日期
					logintime_end: '', //認購截止日期
					logintype:'',
					timeDate: [],
				};
				// this.$refs['seachope'].handleSearch('');
				this.messLoad();
			},
			tzEvent() {
				let _this = this;
				let maxPageNum = Math.ceil(_this.params.total / _this.params.perPage);
				if (_this.tzPageNum <= maxPageNum) {
					_this.params.pageNum = Number(_this.tzPageNum);
					_this.messLoad();
				} else {
					App.oTool.warningT('請輸入有效的頁碼');
				}
			},
			pageChange(page, pageSize) {
				this.params.pageNum = page;
				this.messLoad();
			},
		},
	};
</script>
<style lang='scss'>
	#trpllore {
		.pdfview {
			position: fixed;
			width: 100vw;
			height: 100vh;
			left: 0vw;
			top: 0vh;
			background-color: rgba(0, 0, 0, 0.7);
			z-index: 99;
			display: none;
		}

		.pdfShow {
			display: block;
		}

		.pdfview .pdfviewIn {
			position: fixed;
			width: 80vw;
			height: 80vh;
			left: calc(50% - 40vw);
			top: 5vh;
		}

		.pdfview .pdfviewIn .pdfTitle {
			/* position: absolute;
		    top: 1rem;
		    right:3rem; */
			height: 3rem;
			background-color: #fff;
			width: calc(100% + 1px);
			display: flex;
			align-items: center;
			justify-content: flex-end;
			padding-right: 2rem;
		}

		.pdfview .pdfviewIn .pdfTitle img {
			width: 1.5rem;
			height: 1.5rem;
			margin-left: 1rem;
			cursor: pointer;
		}
	}
</style>
